const HisPlusCircle = ({ color, sx }) => {
  const strokeColor = color ?? "#4C2AC6";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1797 22.1042C17.7025 22.1042 22.1797 17.6271 22.1797 12.1042C22.1797 6.5814 17.7025 2.10425 12.1797 2.10425C6.65684 2.10425 2.17969 6.5814 2.17969 12.1042C2.17969 17.6271 6.65684 22.1042 12.1797 22.1042Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1797 8.10425V16.1042"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.17969 12.1042H16.1797"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisPlusCircle;
